import React, { useEffect, useState } from "react";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import TemplateForm from "./components/TemplateForm";
import "./components/style.css"
import PreviewRcsTemplate from "./components/PreviewRcsTemplate";
import { getRCSSenderID, HOST_URL, NODE_HOST_URL, RCSAPI } from "../api/Api";
import Alert from "../../UI/Alert/Alert";
import Axios from "axios";
import { getAspectAndResolution, getCarouselAspectAndResolution, resetTextareaCounters } from "../../Utils/Utils";
import { validateAllSuggestions } from "./components/SuggestionsButton";

const RcsTemplate = (props) => {

  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  const updateId = props.match.params.id;
  const viewId = props.match.params.viewid

  const [rcsSenderData, setRcsSenderData] = useState([]);
  const [selectSenderId, setselectSenderId] = useState('');
  const [isLoading, setisLoading] = useState(false);
  const [croppedFile, setCroppedFile] = useState([]);
  const [aspectRatio, setAspectRatio] = useState([]);
  const [recommendedResolution, setRecommendedResolution] = useState([]); // or empty
  const [route , setRoute] = useState("");


  const [formData, setFormData] = useState({
    templateName: "",
    templateType: "",
    content: "",
    senderId: '',
    botMessageType: '',
    carousels: [
      {
        "card_width": "",
        "media_height": "",
        "card_title": "",
        "media": {
          "file_type": "",
          "url": ""
        },
        "card_description": "",
        "temp_suggestion": [],
        "dynamic_media_url": false
      },
      {
        "card_width": "",
        "media_height": "",
        "card_title": "",
        "media": {
          "file_type": "",
          "url": ""
        },
        "card_description": "",
        "temp_suggestion": [],
        "dynamic_media_url": false
      }
    ],
    suggestionsButton: [],
    standaloneCard: {
      card_orientation: "",
      card_width: "",
      media_height: "",
      card_alignment: "",
      media: {},
      card_title: "",
      card_description: "",
      temp_suggestion: [],
      dynamic_media_url: false
    },
    activeTabIndex: "0"
  });


  const [error, setError] = useState({
    isError: false,
    messageType: '',
    errorMessage: ''
  })

  useEffect(() => {
    resetTextareaCounters();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle Template Change - Reset data when template changes
  const handleTemplateChange = (e) => {
    const { value } = e.target;
    if (value === "richcardcarousel") {
      setAspectRatio([]);
      setRecommendedResolution([]);
      setCroppedFile([]);
    }
    if (value === "richcardstandalone") {
      setAspectRatio(null);
      setRecommendedResolution("");
      setCroppedFile(null);
    }

    setFormData((prevData) => ({
      ...prevData,
      templateType: value,
      carousels: [
        {
          "card_width": "",
          "media_height": "",
          "card_title": "",
          "media": {
            "file_type": "",
            "url": ""
          },
          "card_description": "",
          "temp_suggestion": [],
          "dynamic_media_url": false
        },
        {
          "card_width": "",
          "media_height": "",
          "card_title": "",
          "media": {
            "file_type": "",
            "url": ""
          },
          "card_description": "",
          "temp_suggestion": [],
          "dynamic_media_url": false
        }
      ],
      suggestionsButton: [],
      content: "",
      standaloneCard: {
        card_orientation: "",
        card_width: "",
        media_height: "",
        cardAlign: "",
        media: {},
        card_title: "",
        card_description: "",
        temp_suggestion: [],
        dynamic_media_url: false
      }, // Reset standalone card data
    }));
  };
  const handleUpload = async (file, fileName, fileType) => {

    const formData = new FormData();
    formData.append("amdfile", file);
    formData.append("doc_name", fileName);
    formData.append("doc_type", fileType);
    formData.append("mediaType", "rcs");
    formData.append("user_id", userId);
    formData.append("token", userToken);
    formData.append("method", "create");
    try {
      const { data } = await Axios
        .post(`${HOST_URL}/uploadFileWhatsapp.php`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      if (data.success) {

        return data.url;
      } else {

        setError({
          isError: true,
          messageType: 'alert-danger',
          errorMessage: data.message
        })
        return false;
      }

    } catch (error) {
      console.log(error);
      throw new Error("something went wrong");


    }

  };



  // create RCS templte
  const createRCSTemplatre = async () => {

    document.getElementById('name-of-template').scrollIntoView({
      behavior: 'smooth'
    })

    setError({
      isError: false,
      messageType: '',
      errorMessage: ''
    })

    setisLoading(true);

    // Validate suggestion buttons before calling API
    let suggestionErrors = [];

    if (formData.templateType === "text") {
      suggestionErrors = validateAllSuggestions(formData.suggestionsButton);
    }

    if (formData.templateType === "richcardstandalone") {
      suggestionErrors = validateAllSuggestions(formData.standaloneCard?.temp_suggestion || []);
    }

    if (formData.templateType === "richcardcarousel") {
      for (let i = 0; i < formData.carousels.length; i++) {
        const carouselErrors = validateAllSuggestions(formData.carousels[i].temp_suggestion || []);
        if (carouselErrors.length > 0) {
          suggestionErrors = carouselErrors;
          break;
        }
      }
    }

    if (suggestionErrors.length > 0) {
      setisLoading(false);
      setError({
        isError: true,
        messageType: 'alert-danger',
        errorMessage: "Please fix invalid URL or phone number in suggestion buttons before submitting."
      });
      return;
    }

    const payload = {
      "user_id": userId,
      "token": userToken,
      "method": updateId ? "update_temp" : "create_temp",
      "sender_id": formData.senderId,
      "temp_name": formData.templateName,
      "temp_language": "en",
      "temp_category": formData.botMessageType,
      "temp_type": formData.templateType,
    }

    if (updateId) {
      payload['temp_id'] = updateId
    }
    if (formData.templateType === 'text') {
      payload['temp_body'] = formData.content
    }

    if (formData.suggestionsButton.length > 0) {
      payload['temp_suggestion'] = formData.suggestionsButton;
    }

    if (formData.templateType === 'richcardstandalone') {
      const standalone = { ...formData.standaloneCard };

      // console.log(standalone);
      

      if (standalone.media?.file) {
        try {
          const uploadedUrl = await handleUpload(
            standalone.media.file,
            standalone.media.file.name,
            standalone.media.file_type
          );
          standalone.media.url = uploadedUrl; // ✅ replace blob URL with real one
          delete standalone.media.file; // optional: clean up file before sending
          if (!uploadedUrl) {
            return;
          }
        } catch (uploadErr) {
          console.error("Upload failed", uploadErr);
          setisLoading(false);
          setError({
            isError: true,
            messageType: 'alert-danger',
            errorMessage: "File upload failed",
          });
          return;
        } finally {
          setisLoading(false);
        }
      }

      payload['rich_card'] = [standalone]
    }

    if (formData.templateType === 'richcardcarousel') {
      const updatedCarousels = [...formData.carousels];

      

      for (let i = 0; i < updatedCarousels.length; i++) {
        const media = updatedCarousels[i].media;
        if (media?.file) {
          try {
            const uploadedUrl = await handleUpload(
              media.file,
              media.file.name,
              media.file.type
            );

            updatedCarousels[i].media.url = uploadedUrl;
            delete updatedCarousels[i].media.file; // cleanup
            if (!uploadedUrl) {
              return;
            }
          } catch (err) {
            console.error("Carousel upload failed", err);
            setisLoading(false);
            setError({
              isError: true,
              messageType: 'alert-danger',
              errorMessage: "Carousel image upload failed",
            });
            return;
          } finally {
            setisLoading(false);
          }
        }
      }

      payload['rich_card'] = updatedCarousels;
    }

    // call API to create RCS tempate
    try {

      let { data } = await RCSAPI(payload);
      if (data.success) {
        setError({
          isError: true,
          messageType: 'alert-success',
          errorMessage: data.message
        })
        setTimeout(() => {
          window.location.href = "/dashboard/rcs-template-list"
        }, 1000)
      } else {
        setisLoading(false);
        setError({
          isError: true,
          messageType: 'alert-danger',
          errorMessage: data.message
        })
      }

    } catch (error) {
      setisLoading(false);
      console.log('error', error)
      setError({
        isError: true,
        messageType: 'alert-danger',
        errorMessage: error?.response?.data?.message
      })
    }

  }

  // console.log(updatedCarousels[i].media);
  

  // fetch al sender id details

  useEffect(() => {
    const getRCSData = async () => {
      try {
        const paylod = {
          "user_id": userId,
          "token": userToken,
          "method": 'retrieve_bot'
        }
        let { data } = await getRCSSenderID(paylod);
        setRcsSenderData(data.data)
        let foundBot = data.data.find(
          (item) => item.bot_id === formData.senderId
        );
        const routeId = foundBot?.route;
        // console.log(routeId);
        setRoute(routeId)        

      } catch (error) {
        console.log('error', error)
      }
    }
    getRCSData();
  }, [formData.senderId])


  const sernderHandler = (e) => {
    let id = e.target.value;


    if (id) {
      let selectdSenderId = rcsSenderData.filter((item) => item.bot_id === id)


      setselectSenderId(selectdSenderId)

      setFormData((prevData) => ({
        ...prevData, senderId: id, botMessageType: selectdSenderId[0].type
      }));
    } else {
      setselectSenderId('')
      setFormData((prevData) => ({
        ...prevData, senderId: '', botMessageType: ""
      }));
    }

  }

  // fetch template of data form ID
  useEffect(() => {
    if (updateId || viewId) {
      const paylod = {
        "user_id": userId,
        "token": userToken,
        "method": 'retrieve_temp_dtl',
        "temp_id": updateId ? updateId : viewId
      }
      const fetchRCSTemplateData = async () => {
        let { data } = await RCSAPI(paylod);
        let fetchData = data.data;

        const isCarousel = fetchData.temp_type === "richcardcarousel";
        const isStandalone = fetchData.temp_type === "richcardstandalone";

        const updatedAspectRatios = [];
        const updatedResolutions = [];

        if (isCarousel) {
          fetchData.rich_card.forEach((card) => {
            const { aspectRatio, resolution } = getCarouselAspectAndResolution(card.media_height, card.card_width);
            updatedAspectRatios.push(aspectRatio);
            updatedResolutions.push(resolution);
          });
          setAspectRatio(updatedAspectRatios);
          setRecommendedResolution(updatedResolutions);
        }

        if (isStandalone && fetchData.rich_card.length > 0) {
          const { card_orientation, media_height } = fetchData.rich_card[0];
          const { aspectRatio, resolution } = getAspectAndResolution(card_orientation, media_height);
          setAspectRatio(aspectRatio);
          setRecommendedResolution(resolution);
        }

        setFormData({
          templateName: fetchData.temp_name,
          templateType: fetchData.temp_type,
          content: fetchData.temp_body,
          senderId: fetchData.sender_id,
          botMessageType: fetchData.temp_category,
          carousels: fetchData.temp_type === "richcardcarousel" ? fetchData.rich_card : [],
          suggestionsButton: fetchData.temp_suggestion,
          standaloneCard: fetchData.temp_type === "richcardstandalone" ? fetchData.rich_card[0] : [],
        })
      }
      fetchRCSTemplateData();
    }
  }, [])



  return (

    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card">
                  <div className="card-body">
                    <form id="formSmstemplate">
                      <div className="row justify-content-center">
                        <div className="mb-3 col-md-12">
                          <div id="name-of-template" className="text-left">
                            <h3 className="font-weight-bold mb-4">
                              {updateId ? 'Update' : viewId ? 'View' : ' Create New'}    RCS Template
                            </h3>
                          </div>


                          {error.isError && (
                            <Alert type={error.messageType}>
                              {error.errorMessage}
                            </Alert>
                          )}


                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <input
                                type="text"
                                className="form-control"
                                name="templateName"
                                value={formData.templateName}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  // Allow only alphanumeric and underscore, with a max length of 20
                                  if (/^[a-zA-Z0-9_]{0,20}$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                placeholder="Enter Template Name"
                                maxLength={20}
                              />

                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group drop-down-icons col-md-6">
                              <select
                                className="form-control"
                                name="senderId"
                                value={formData.senderId}
                                onChange={sernderHandler}
                              >
                                <option value="">Select Bot ID</option>
                                {rcsSenderData && rcsSenderData.map((item, i) =>
                                  <option key={i} value={item.bot_id}>{item.bot_name}</option>
                                )}

                              </select>
                            </div>
                            <hr class="m-0" />

                            <div className="form-group col-md-6">
                              <select
                                className="form-control"
                                name="botMessageType"
                                disabled
                                value={selectSenderId[0]?.type}
                                onChange={handleChange}
                              >
                                <option value="">Type</option>
                                <option value="promotional">Promotional</option>
                                <option value="transactional">Transactional</option>
                                <option value="otp">OTP</option>
                              </select>
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group drop-down-icons col-md-12">
                              <select
                                className="form-control"
                                name="templateType"
                                value={formData.templateType}
                                onChange={handleTemplateChange}
                              >
                                <option value="">Select Template Type</option>
                                <option value="text">Text</option>
                                <option value="richcardcarousel">Rich card carousal</option>
                                <option value="richcardstandalone">Rich card Stand Alone</option>
                              </select>
                            </div>
                          </div>

                          <TemplateForm
                            templateType={formData.templateType}
                            formData={formData}
                            setFormData={setFormData}
                            setCroppedFile={setCroppedFile}
                            aspectRatio={aspectRatio}
                            setAspectRatio={setAspectRatio}
                            recommendedResolution={recommendedResolution}
                            setRecommendedResolution={setRecommendedResolution}
                            route = {route}
                          />

                          {isLoading ?

                            <div className="text-right">
                              <button
                                type="button"
                                className="btn btn-sm mt-3 btn-primary"
                              >
                                Loading....
                              </button>
                            </div>
                            :
                            <div className="text-right">
                              <button
                                type="button"
                                onClick={() => createRCSTemplatre()}
                                className="btn btn-sm mt-3 btn-primary"
                                disabled={viewId ? true : false}
                              >
                                {updateId ? 'Update' : 'Create'} RCS Template
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="col-md-4">

                <div className="collapse show" id="collapseExample">
                  <div className="links-set">

                    <PreviewRcsTemplate formData={formData} setFormData={setFormData} />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </main>
        <DashboardFooter />
      </div>
    </div>
  );

}

export default RcsTemplate;